import { atom } from 'jotai';

// Raw password sent on every request as `secret`
export const secretAtom = atom<string | null>(
  sessionStorage.getItem('op_secret')
);

// Session token returned by /panel/data, included as `session_token` in every request
export const sessionTokenAtom = atom<string | null>(
  sessionStorage.getItem('op_session')
);

// Write atoms that also persist to sessionStorage
export const writeSecretAtom = atom(
  null,
  (_get, set, value: string | null) => {
    set(secretAtom, value);
    if (value) sessionStorage.setItem('op_secret', value);
    else sessionStorage.removeItem('op_secret');
  }
);

export const writeSessionAtom = atom(
  null,
  (_get, set, value: string | null) => {
    set(sessionTokenAtom, value);
    if (value) sessionStorage.setItem('op_session', value);
    else sessionStorage.removeItem('op_session');
  }
);
